// The group's sheet in Grupe curs, on tabs (03.11.2026, decisions A–E):
// which tabs whom, the one-line summary on top, and what a tab flags.

export const TEAM = ["owner", "admin", "admin_fped"];

const STATUS = { active: "Activă", full: "Plină", inactive: "Inactivă", draft: "Ciornă" };
const FORMAT = { online: "Online", offline: "Față în față", hybrid: "Hibrid" };
const MONTHS = ["ian.", "feb.", "mar.", "apr.", "mai", "iun.", "iul.", "aug.", "sept.", "oct.", "nov.", "dec."];

export const isInstitution = (group) => group?.billing_mode === "institution";

/** The tabs this person sees for this group, in order. */
export function tabsFor(role, group) {
  const team = TEAM.includes(role);
  return [
    { key: "participanti", label: "Participanți" },
    { key: "program", label: "Program" },
    ...(team ? [{ key: "chestionare", label: "Chestionare" }] : []),
    ...(team && isInstitution(group) ? [{ key: "institutie", label: "Instituție" }] : []),
  ];
}

/** The tab to open: the one asked for when this person may see it, else Participanți. */
export function pickTab(wanted, tabs) {
  return tabs.some((t) => t.key === wanted) ? wanted : "participanti";
}

export const statusLabel = (s) => STATUS[s] || s || "—";
export const formatLabel = (f) => FORMAT[f] || (f ? f.charAt(0).toUpperCase() + f.slice(1) : "—");

/** "4 nov. 2026" from "2026-11-04". */
export function dayLabel(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || "");
  if (!m) return "—";
  return `${Number(m[3])} ${MONTHS[Number(m[2]) - 1]} ${m[1]}`;
}

/** "4 nov. – 25 nov. 2026", the year once when both ends share it. */
export function periodLabel(start, end) {
  if (!start) return "";
  if (!end || end === start) return dayLabel(start);
  const a = dayLabel(start);
  const b = dayLabel(end);
  return start.slice(0, 4) === end.slice(0, 4) ? `${a.slice(0, -5)} – ${b}` : `${a} – ${b}`;
}

/** "Activă · 4 nov. – 25 nov. 2026 · Luni și Joi, 18:00–20:00 · Online · 13/25 locuri" */
export function summaryLine(group, stats) {
  if (!group) return "";
  const days = (group.schedule_days || []);
  const when = [days.length > 1 ? `${days.slice(0, -1).join(", ")} și ${days[days.length - 1]}` : days[0],
    group.schedule_time].filter(Boolean).join(", ");
  const seats = stats?.max_spots ? `${stats.total}/${stats.max_spots} locuri` : stats ? `${stats.total} înscriși` : "";
  return [statusLabel(group.status), periodLabel(group.start_date, group.end_date), when,
    group.format ? formatLabel(group.format) : "", seats].filter(Boolean).join(" · ");
}

/** True once the session is over, by the clock given (tests) or now. */
export function isHeld(session, now = new Date()) {
  if (!session?.date) return false;
  const end = new Date(`${session.date}T${session.end_time || "23:59"}:00`);
  return !Number.isNaN(end.getTime()) && end <= now;
}

/**
 * Whether the questionnaires ask for something (decision A): the initial
 * assessment sent by hand with people still to send to, or the final
 * feedback through the trainer, due, open and with people missing.
 */
export function questionnairesTodo(assessment, feedback, now = new Date()) {
  const a = assessment && !assessment.failed && assessment.applies
    && assessment.mode?.mode === "manual" && (assessment.counts?.not_sent || 0) > 0;
  const due = feedback?.send_at ? new Date(feedback.send_at) <= now : false;
  const toSend = (feedback?.missing || []).filter((m) => m.state !== "closed").length;
  const f = feedback && !feedback.failed && feedback.mode === "trainer" && due && !feedback.closed && toSend > 0;
  return Boolean(a || f);
}

/** Who is listed under each switch above the table (decision B). */
export const VIEWS = [
  { key: "in", label: "În grupă" },
  { key: "left", label: "Au ieșit" },
  { key: "expired", label: "Neplătite în termen" },
];
